module.exports = __webpack_public_path__ + "./fonts/icomoon.8b7948.eot";